var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMegaphoneIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10302_4241)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.7968 16.5028L11.4221 20.6159L3.19599 15.8665L5.57067 11.7534L13.7968 16.5028ZM10.0615 32.4711C7.24426 32.7914 3.5575 33.2404 0.6429 33.5868C0.449577 32.0219 0.26813 30.4364 0.0748068 28.8715C2.98941 28.5251 6.67617 28.0762 9.50532 27.7353C9.68677 29.3208 9.86822 30.9062 10.0615 32.4711ZM15.2728 2.5479C16.7247 1.93287 18.1884 1.29728 19.6403 0.68225C20.7977 3.37955 22.2522 6.79687 23.3716 9.41742C21.9197 10.0324 20.4559 10.668 19.004 11.2831C17.8847 8.66251 16.4182 5.26576 15.2728 2.5479ZM44.9629 29.0125C47.2251 30.3185 48.0074 33.238 46.7013 35.5002L44.3266 39.6133C43.0206 41.8755 40.1011 42.6577 37.8389 41.3517L35.7824 40.1643L31.033 48.3905L26.9199 46.0158L31.6693 37.7897L29.6128 36.6023L15.7681 36.8352L30.0162 12.1568L36.7368 24.2631L44.9629 29.0125ZM17.7508 21.5277C19.33 18.7925 21.9475 17.0133 24.8132 16.4193L16.8699 30.1775C15.9396 27.4194 16.1716 24.2629 17.7508 21.5277Z",
    fill: "#83CEFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10302_4241"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMegaphoneIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/megaphoneIcon.99e7c11679446a9842dac4f6f109d245.svg";